module.exports = __webpack_public_path__ + "static/image-5f8a23998fdcbc3e551e81657c2e7347.jpg";